module.exports = __webpack_public_path__ + "assets/img/budapark1-320.6dba0f9c.webp";